<template>
    <div class="card-param-form">
        <h4 v-if="!editing">{{kpi.name}}</h4>
        <div class="form-line" v-if="editing">
            <rir-input
                    v-model="kpi.name"
                    label="Название"
            />
        </div>
        <div class="form-line" v-if="editing">
            <rir-input
                    v-model="kpi.order"
                    label="Порядок"
            />
        </div>

        <div class="form-line"
             v-for="(kpi, index) in childrenKpi"
             :key="index">
            <KpiEditField :kpi="kpi" :editing="editing"></KpiEditField>
        </div>

        <div class="form-line" v-if="!editing">
            <rir-button
                    color="primary"
                    @click="edit()"
            >Редактировать</rir-button>
        </div>
        <div class="form-line" v-if="editing">
            <rir-button
                    color="primary"
                    @click="save()"
                    :disabled="!canSave"
            >
                <span v-if="!creating">Сохранить</span>
                <span v-if="creating">Добавить</span>
            </rir-button>
        </div>
        <div class="form-line clearfix" v-if="editing && !creating">
            <div class="left-half">
                <rir-button
                        color="error"
                        @click="cancel()"
                >Отмена</rir-button>
            </div>
            <div class="right-half">
                <rir-button
                        color="error"
                        @click="deleteKpi()"
                >Удалить</rir-button>
            </div>
        </div>
        <div class="form-line clearfix" v-if="editing && creating">
            <rir-button
                    color="error"
                    @click="cancel()"
            >Отмена</rir-button>
        </div>
    </div>
</template>

<script>
    import {KpiApi} from '../api/KpiApi';
    import Kpi from "../models/Kpi";
    import KpiEditField from "./KpiEditField";

    export default {
        name: 'EventEditForm',
        components: {
            KpiEditField
        },
        props: {
            kpi: {
                type: Object,
                default: () => new Kpi()
            },
            creating: {
                type: Boolean,
                default: () => false
            }
        },
        data () {
            return {
                editing: false,
                initialKpi: new Kpi(),
                childrenKpi: [],
                listOfStyles: [
                    {id: 'none', value: 'нет'},
                    {id: 'is-normal', value: 'в норме'},
                    {id: 'is-invalid', value: 'превышен'},
                ],
            }
        },
        computed: {
            canBeParent() {
                return !this.kpi.parentId;
            },
            typeInput() {
                return ['string', 'int', 'double'].indexOf(this.kpi.dataType) != -1;
            },
            typeMinMax() {
                return ['int', 'double'].indexOf(this.kpi.dataType) != -1;
            },
            typeDate() {
                return this.kpi.dataType == 'date';
            },
            typeBool() {
                return this.kpi.dataType == 'bool';
            },
            canSave() {
                return this.kpi.name.length > 0;
            },
            canAddChild() {
                return this.kpi.maxChildrenCount > this.childrenKpi.length;
            }
        },
        watch: {
            kpi(val) {
                if (!this.initialKpi.id) {
                    this.initialKpi = new Kpi(val);
                    this.loadChilrenKpi();
                }
            }
        },
        mounted() {
            this.loadChilrenKpi();
        },
        methods: {
            async loadChilrenKpi() {
                let childrenKpi = await KpiApi.getList({
                    parentId: this.kpi.id,
                    page: 0,
                    size: this.kpi.maxChildrenCount || 1
                });
                this.childrenKpi = childrenKpi.content.map(el => {
                    if (this.creating) {
                        el.id = null;
                        el.value = '';
                    }
                    return new Kpi(el);
                });
                if (this.creating) {
                    this.kpi.id = null;
                    this.kpi.name = '';
                    this.editing = true;
                }
            },
            edit() {
                this.editing = true;
            },
            async save() {
                this.editing = false;
                let res;
                if (this.kpi.id) {
                    res = await KpiApi.update(this.kpi.getDataToSave());
                } else {
                    res = await KpiApi.create(this.kpi.getDataToSave());
                    if (res && res.data && res.data.id) {
                        this.kpi.id = res.data.id;
                    }
                }
                if (res) {
                    this.initialKpi = new Kpi(this.kpi);
                    this.childrenKpi.forEach(kpi => {
                        this.saveChild(kpi);
                    });
                }
                this.$emit('onSave');
            },
            async saveChild(kpi) {
                this.editing = false;
                kpi.parentId = this.kpi.id;
                let res;
                if (kpi.id) {
                    res = await KpiApi.update(kpi.getDataToSave());
                } else {
                    res = await KpiApi.create(kpi.getDataToSave());
                    if (res && res.data && res.data.id) {
                        kpi.id = res.data.id;
                    }
                }
            },
            cancel() {
                this.editing = false;
                this.$emit('update:kpi', new Kpi(this.initialKpi));
                this.$emit('onCancel');
            },
            async deleteKpi() {
                this.childrenKpi.forEach(kpi => {
                    KpiApi.delete(kpi.id);
                });
                await KpiApi.delete(this.kpi.id);
                this.$emit('onDelete');
            }
        }
    }
</script>

<style scoped>

</style>
